export default __webpack_public_path__ + "static/element-1.url-45cdea8de257719b68fcfe57eb8d183f.svg";